// src/admin/Dashboard.jsx
import {React, useEffect} from "react";

export default function Dashboard() {
   useEffect(() => {
      document.title = "Dashboard | Development Solutions";
    }, []);
  return (
    <div>
      <h1 className="text-2xl font-bold">Welcome to Admin Dashboard</h1>
      <p className="mt-2 text-gray-600">Manage your website content here.</p>
    </div>
  );
}
